import {
  Box,
} from '@mui/material';
import LimiterInput from './LimiterInput';
import { InputLimits } from '../../../../enums/InputLimits';

function SEOSetting(props: {
  headerScript: string,
  bodyScript: string,
  onHeaderScriptChange: (value: string) => void,
  onBodyScriptChange: (value: string) => void,
}) {
  const {
    headerScript,
    bodyScript,
    onHeaderScriptChange,
    onBodyScriptChange,
  } = props;
  return (
    <Box display="flex" flexDirection="column" rowGap="10px">
      <div className="col-form-label text-bold">Custom Code</div>
      <p className="mb-2">Add custom tags to the &lt;head&gt; or &lt;body&gt;.</p>

      <div className="row my-3">
        <div className="col-lg-9">
          <LimiterInput
            textarea
            label="Inside <head> tag"
            limit={InputLimits.SEO_HEADER_SCRIPT}
            value={headerScript || ''}
            placeholder="Paste code here"
            onChange={(newValue) => onHeaderScriptChange(newValue)}
          />
          <div className="text-sm">*Allowed tags: &lt;meta&gt;, &lt;script&gt;, &lt;style&gt;, &lt;link&gt;, &lt;noscript&gt;, &lt;!----&gt;,</div>
        </div>

        <div className="col-lg-3">
          <div className="d-flex flex-column">
            <div className="my-2">*Example:</div>
            <div>- Google Tag Manager</div>
            <div>- Facebook Pixel</div>
          </div>
        </div>
      </div>

      <div className="row my-3">
        <div className="col-lg-9">
          <LimiterInput
            textarea
            label="Before </body> tag"
            limit={InputLimits.SEO_BODY_SCRIPT}
            value={bodyScript || ''}
            placeholder="Paste code here"
            onChange={(newValue) => onBodyScriptChange(newValue)}
          />
          <div className="text-sm">*Allowed tags: &lt;script&gt;, &lt;style&gt;, &lt;link&gt;, &lt;noscript&gt;, &lt;!----&gt;,</div>
        </div>

        <div className="col-lg-3">
          <div className="d-flex flex-column">
            <div className="my-2">*Example:</div>
            <div>- Google Tag Manager</div>
            <div>- Yahoo! Tag Manager</div>
          </div>
        </div>
      </div>
    </Box>
  );
}

export default SEOSetting;
